import React, { useState } from 'react';
import { useFormik } from 'formik';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import { makeStyles } from '@material-ui/core/styles';
import { useAuth } from '../context/auth';
import {
  Container,
  TextField,
  Typography,
  CssBaseline,
  Button,
  Avatar
} from '@material-ui/core';
import {login} from "../api/login";

export default function Login({ history }) {
  const { setAuthToken } = useAuth();
  const [errors, setErrors] = useState(null);

  const formik = useFormik({
    initialValues: {
      email: '',
      password: ''
    },
    async onSubmit(values) {
      try {
        const response = await login(values);
        const token = response.data.token;
        setAuthToken(token);
        history.push('/');
      } catch (e) {
        setErrors(e.response.data.error);
      }
    },
  });

  const classes = useStyles();

  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <div className={classes.paper}>
        <Avatar className={classes.avatar}>
          <LockOutlinedIcon />
        </Avatar>
        <Typography component="h1" variant="h5">
          Zenfit Gym
        </Typography>
        <form className={classes.form} onSubmit={formik.handleSubmit} noValidate>
          <TextField
            id="email"
            name="email"
            type="email"
            onChange={formik.handleChange}
            value={formik.values.email}
            variant="outlined"
            margin="normal"
            required
            fullWidth
            error={errors ? true : false}
            label="Email Address"
            autoComplete="email"
            autoFocus
          />
          <TextField
            id="password"
            name="password"
            type="password"
            onChange={formik.handleChange}
            value={formik.values.password}
            variant="outlined"
            margin="normal"
            required
            fullWidth
            error={errors ? true : false}
            label="Password"
            autoComplete="current-password"
          />
          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            className={classes.submit}
          >
            Sign In
          </Button>
        </form>
      </div>
    </Container>
  );
}

const useStyles = makeStyles(theme => ({
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));
